import React from 'react';
import { windowWrapper } from '@clubmed/utils';
import { t } from 'Src/i18n';
import { ID_MODAL_HEADER__PLE__LOGIN } from 'Components/utils/identifiers/constants';
import { ICONS } from 'Components/utils/icon/icons';
import * as TrackingApi from 'Tracking/tracking-api';
import * as pleUtils from 'Utils/ple-utils';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { useAppContext } from 'Context/ReactAppContext';
import { BE_GA_DEFAULT_PAYLOAD } from 'Views/booking/constants';
import { Button } from 'Components/frameworks/button/Button';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Modal } from 'Components/frameworks/modal/Modal';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  i18n: CMSContent;
  onClose: () => void;
};
export const PopinLoginToPle = ({ i18n, onClose }: Props) => {
  const appContext = useAppContext();
  const {
    message,
    bulletpoint1,
    bulletpoint2,
    bulletpoint3,
    buttonLabel,
    noAccountSentence,
    noAccount,
  } = i18n.booking.participants.connectToPLE;
  return (
    <Modal
      ariaLabel={message}
      ariaLabelledby={ID_MODAL_HEADER__PLE__LOGIN}
      closeLabel={t('common.close')}
      onClose={onClose}
      size="small"
      dataTestId="connexion-popin"
    >
      <div className="font-sans">
        <div className="bg-lightSand p-20 text-center font-bold">
          <Icon className="text-sienna" isNotSquare name={ICONS.PEOPLE} width="3.5625rem" />
          <Title
            className="mt-10 justify-center text-sienna"
            hLevel={1}
            id={ID_MODAL_HEADER__PLE__LOGIN}
            theme="title-sans-n4"
          >
            {message}
          </Title>
        </div>
        <ul className="p-20">
          {[bulletpoint1, bulletpoint2, bulletpoint3].map((bulletpoint) =>
            bulletpoint ? (
              <li key={bulletpoint}>
                <Icon className="me-10 align-middle text-green" name={ICONS.CHECK} />
                {bulletpoint}
              </li>
            ) : null,
          )}
        </ul>
        {isFeatureFlipped(appContext)('booking.displayFutureTravelCredit') && (
          <div className="mx-auto flex w-full max-w-440 flex-wrap justify-center p-20 pt-0">
            <div className="flex items-center gap-20 font-brand text-14 text-lavender">
              <Icon className="shrink-0" name={ICONS.PROMO_CODE} width="2.5rem" />
              {t('booking.summary.futureTravelCredit.popinFtcTitle')}
            </div>
            <div className="text-12">{t('resort.futureTravelCredit.genericDescription')}</div>
          </div>
        )}
        <div className="pb-20 text-center">
          <Button
            className="mb-20 w-3/4"
            data-testid="loggin-button"
            isExternalLink
            onClick={() => {
              TrackingApi.setDataLayer(
                {
                  ...BE_GA_DEFAULT_PAYLOAD,
                  actionGA: 'participant',
                  labelGA: 'popin_connectionParticipant',
                  versionBooking: 'responsive',
                },
                appContext,
              );
            }}
            url={pleUtils.buildSigninUrl({
              locale: appContext.locale,
              redirectUri: windowWrapper.getLocation(),
            })}
          >
            {buttonLabel}
          </Button>
          <div className="px-20">
            <p className="font-bold">{noAccount}</p>
            <p>{noAccountSentence}</p>
          </div>
        </div>
      </div>
    </Modal>
  );
};
